module.exports = __webpack_public_path__ + "static/media/step-2.123ff54f.png";